import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { I18nProvider } from './utils/i18n';
(function injectGtag() {
  const GA_ID = 'G-3RE9CS5GWX';
  // Avoid duplicate injection
  if (document.querySelector(`script[src*="${GA_ID}"]`)) return;
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script1);
  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_ID}');
  `;
  document.head.appendChild(script2);
})();
render(<I18nProvider data-id="element-1274">
    <App data-id="element-1275" />
  </I18nProvider>, document.getElementById('root'));